import { createContext, useContext } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreatePaymentLink, createPaymentLinkSchemaSchema } from "./CreatePaymentLinkSchema";

const CreatePaymentLinkContext = createContext<any>(null);

export const CreatePaymentLinkProvider = ({ children }: { children: React.ReactNode }) => {
  const methods = useForm<CreatePaymentLink>({
    resolver: zodResolver(createPaymentLinkSchemaSchema),
    mode: "all",
    defaultValues: {
      amount: "",
      currency: "EGP",
      paymentCategory: "",
      paymentFor: "",
      expiryDate: undefined,
      recipientsType: "INDIVIDUALS",
      recipientsOutSideGoalngo: [],
      registerFormFields: [
        {
          title: "fullName",
          required: true,
          default: true,
        },
        {
          title: "email",
          required: true,
          default: true,
        },
        {
          title: "phoneNumber",
          required: true,
          default: true,
        },
        {
          title: "currentRole",
          required: true,
          default: true,
        },
      ],
    },
  });

  return (
    <FormProvider {...methods}>
      <CreatePaymentLinkContext.Provider value={methods}>{children}</CreatePaymentLinkContext.Provider>
    </FormProvider>
  );
};

export const useCreatePaymentLink = () => useContext(CreatePaymentLinkContext);
